"use client"

import { createContext, useContext, useState, useEffect } from "react"

// Create context
const UIContext = createContext()

// Provider component
export const UIProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  const [isMobile, setIsMobile] = useState(false)

  // Check if screen is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768)
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false)
      } else {
        setIsSidebarOpen(true)
      }
    }

    checkIfMobile()
    window.addEventListener("resize", checkIfMobile)

    return () => {
      window.removeEventListener("resize", checkIfMobile)
    }
  }, [])

  // Toggle sidebar
  const toggleSidebar = (value) => {
    if (typeof value === "boolean") {
      setIsSidebarOpen(value)
    } else {
      setIsSidebarOpen((prev) => !prev)
    }
  }

  // Context values
  const value = {
    isSidebarOpen,
    toggleSidebar,
    isMobile,
  }

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>
}

// Custom hook to use the UI context
export const useUIContext = () => {
  const context = useContext(UIContext)
  if (context === undefined) {
    throw new Error("useUIContext must be used within a UIProvider")
  }
  return context
}

